module.exports = __webpack_public_path__ + "static/media/what-the-hex.6ec14ee2.png";